<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("RESELLER_SERVICES.ADD_RESELLER_SERVICE") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <reseller-service-form
              :loading="loading"
              :resellerServiceData="resellerService"
              :formErrors="formErrors"
              @resellerServiceSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultResellerService from "./defaultResellerService";
import ResellerServiceForm from "./partials/ResellerServiceForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ResellerServiceForm,
  },

  mixins: [alertLeave],

  data() {
    const resellerService = cloneDeep(defaultResellerService);
    return {
      resellerService: resellerService,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List ResellerServices" });
    },

    viewResellerService(resellerService) {
      this.alertLeave = false;
      this.$router.push({
        name: "View ResellerService",
        params: { id: resellerService.id },
      });
    },

    async handleSubmit(resellerService) {
      this.loading = true;

      const resellerServiceData = cloneDeep(resellerService);
      delete resellerServiceData.id;

      try {
        await this.$store.dispatch("resellerServices/add", resellerServiceData);
        this.$notify({
          type: "success",
          message: this.$t("RESELLER_SERVICES.RESELLER_SERVICE_ADDED"),
        });
        const resellerService = await this.$store.getters[
          "resellerServices/resellerService"
        ];
        this.viewResellerService(resellerService);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        const resellerService = await this.$store.getters[
          "resellerServices/resellerService"
        ];
        if (resellerService.id) {
          await this.$store.dispatch(
            "resellerServices/destroy",
            resellerService.id
          );
        }
        this.loading = false;
      }
    },
  },
};
</script>
